class DriverListingModel {
  constructor({
    next = null,
    previous = null,
    count = null,
    pageCount = null,
    results = [],
  } = {}) {
    this.next = next;
    this.previous = previous;
    this.count = count;
    this.pageCount = pageCount;
    this.results = results.map((result) => new Results(result));
  }

  static fromJson(json) {
    return new DriverListingModel({
      next: json.next,
      previous: json.previous,
      count: json.total_elements,
      pageCount: json.total_pages,
      results: (json.content || []).map((item) => Results.fromJson(item)),
    });
  }

  toJson() {
    return {
      next: this.next,
      previous: this.previous,
      total_elements: this.count,
      total_pages: this.pageCount,
      results: this.results.map((result) => result.toJson()),
    };
  }
}

class Results {
  constructor({
    id = null,
    isDeleted = null,
    profileImageUrl = null,
    uid = null,
    name = null,
    phoneCode = null,
    phoneNumber = null,
    email = null,
    licenseCode = null,
    licenseValidity = null,
    status = null,
    licenseIdImageUrl = null,
    nationalIdImageUrl = null,
    reportingCenter = null,
  } = {}) {
    this.id = id;
    this.isDeleted = isDeleted;
    this.profileImageUrl = profileImageUrl;
    this.uid = uid;
    this.name = name;
    this.phoneCode = phoneCode;
    this.phoneNumber = phoneNumber;
    this.email = email;
    this.licenseCode = licenseCode;
    this.licenseValidity = licenseValidity;
    this.status = status;
    this.licenseIdImageUrl = licenseIdImageUrl;
    this.nationalIdImageUrl = nationalIdImageUrl;
    this.reportingCenter = reportingCenter;
  }

  static fromJson(json) {
    return new Results({
      id: json.id,
      isDeleted: json.is_deleted,
      profileImageUrl: json.profile_image_url,
      uid: json.uid,
      name: json.name,
      phoneCode: json.phone_code,
      phoneNumber: json.phone_number,
      email: json.email,
      licenseCode: json.license_code,
      licenseValidity: json.license_validity,
      status: json.status,
      licenseIdImageUrl: json.license_id_image_url,
      nationalIdImageUrl: json.national_id_image_url,
      reportingCenter: json.reporting_center,
    });
  }

  toJson() {
    return {
      id: this.id,
      is_deleted: this.isDeleted,
      profile_image_url: this.profileImageUrl,
      uid: this.uid,
      name: this.name,
      phone_code: this.phoneCode,
      phone_number: this.phoneNumber,
      email: this.email,
      license_code: this.licenseCode,
      license_validity: this.licenseValidity,
      status: this.status,
      license_id_image_url: this.licenseIdImageUrl,
      national_id_image_url: this.nationalIdImageUrl,
      reporting_center: this.reportingCenter,
    };
  }
}

export { DriverListingModel };
